export class SetFileDto {
  fileId: string
}
